module.exports = __webpack_public_path__ + "static/media/active_directory_logo.cf6e784c.png";